<template>
  <div class="full-height">
    <div class="filter">
      <div class="left">
        <div class="title">
          上会分类:
          <a-select
            class="filter-item"
            v-model="filterInfo.meetingCategory"
            :allowClear="true"
            style="width: 150px"
            @change="handleFilterChange('会议-已排会-筛选上会分类', filterInfo.meetingCategory)"
          >
            <a-select-option v-for="i in [6, 1, 2, 3, 5]" :key="i">
              {{ meetingCategoryMap[i] }}
            </a-select-option>
          </a-select>
        </div>

        <div class="title">
          参会人:
          <a-select
            class="filter-item"
            v-model="filterInfo.isMeetingUser"
            :allowClear="true"
            style="width: 120px"
            @change="handleFilterChange('会议-已排会-筛选参会人')"
          >
            <a-select-option v-for="i in [{ id: 1, label: '我参会的' }]" :key="i.id">
              {{ i.label }}
            </a-select-option>
          </a-select>
        </div>

        <div class="title">
          DL:
          <a-select
            class="filter-item"
            v-model="filterInfo.dl"
            :allowClear="true"
            style="width: 120px"
            @change="handleFilterChange('会议-已排会-筛选DL')"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option v-for="i in DLList" :key="i.id">
              {{ i.nickname }}
            </a-select-option>
          </a-select>
        </div>

        <div class="title">
          上会日期:
          <a-date-picker
            class="filter-item"
            v-model="filterInfo.meetingDate"
            :allowClear="true"
            style="width: 150px"
            @change="handleFilterChange('会议-已排会-筛选上会日期')"
          />
        </div>
      </div>

      <a-input-search
        class="right"
        v-model="filterInfo.companyName"
        placeholder="请输入项目名称搜索"
        style="width: 300px"
        @search="handleFilterChange('会议-已排会-搜索项目名')"
      />
    </div>
    <div class="bg_white meeting-table">
      <a-table
        :loading="loading"
        :columns="meetingListColumns"
        :customRow="
          record => {
            return {
              on: {
                // 事件
                click: event => {
                  gotoMeetingDetail(record);
                } // 点击行
              }
            };
          }
        "
        :dataSource="meetingList"
        :pagination="false"
        :rowKey="row => row.meetingProjectId"
        data-ga-id="会议-已排会-点击会议列表"
      >
        <span slot="name" slot-scope="row">
          <div class="project-name">
            <a-tooltip>
              <template slot="title">
                {{ row.name }}
              </template>
              <a data-ga-id="会议-已排会-点击列表项目名" @click.stop="toProjectDetail(row)">
                {{ row.name }}
              </a>
            </a-tooltip>
          </div>
          <div class="tag-list" style="white-space: nowrap; margin: -2px 0 0 0; pointer-events: none; zoom: 0.8; line-height: 2">
            <a-tag color="#f5222d" v-if="row.secret"> 保密 </a-tag>
            <a-tag color="#87d068" v-if="row.followType === 0"> Follow On </a-tag>
            <a-tag color="#2db7f5" v-if="row.subsidiary === 1"> 上市公司拆分 </a-tag>
            <a-tag color="#108ee9" v-if="row.ifIpo === 1"> 预计3年内IPO </a-tag>
          </div>
        </span>
        <div slot="description" slot-scope="record" class="description">
          <a-tooltip>
            <template slot="title">
              {{ record }}
            </template>
            {{ record }}
          </a-tooltip>
        </div>
        <div slot="meetingDate" slot-scope="row">
          {{ row.endTime ? moment.unix(row.startTime).format('YYYY-MM-DD HH:mm') + ' - ' + moment.unix(row.endTime).format('HH:mm') : '' }}
        </div>
        <div slot="action" slot-scope="row">
          <div v-if="row.ifCanManage" class="editicon-container">
            <a @click.stop="openGroupEdit(row)" v-if="btnPermission.includes('update') && row.meetingType !== 2">编辑</a>
            <a style="color: #f52207" @click.stop="showConfirm(row)" v-if="btnPermission.includes('delete')">删除</a>
          </div>
          <div v-else class="checkicon-container">
            <!-- 关联会议录音 -->
            <div class="item-checkicon">
              <a-tooltip placement="top" @click.stop="gotoAudio(row)" data-ga-id="会议-已排会-点击列表会议录音">
                <template slot="title">
                  <span v-if="row.audio.status == 2">未上传录音，点击跳转到会议详情页上传</span>
                  <span v-if="row.audio.status == 3">上传录音</span>
                  <span v-if="row.audio.status == 4">已上传录音，点击查看</span>
                </template>
                <div v-if="row.audio.status == 2" class="icon">
                  <img src="/common/audioUnDone.png" />
                </div>
                <div v-if="row.audio.status == 3" class="icon">
                  <img src="/common/audioDefault.png" />
                </div>
                <div v-if="row.audio.status == 4" class="icon">
                  <img src="/common/audioDone.png" />
                </div>
              </a-tooltip>
            </div>
            <!-- 关联会议纪要 -->
            <div class="item-checkicon">
              <a-tooltip placement="top" @click.stop="gotoSummary(row)" data-ga-id="会议-已排会-点击列表会议纪要">
                <template slot="title">
                  <span v-if="row.summary.status == 2">未上传纪要</span>
                  <span v-if="row.summary.status == 3">上传纪要</span>
                  <span v-if="row.summary.status == 4">已上传纪要</span>
                </template>
                <div v-if="row.summary.status == 2" class="icon">
                  <img src="/common/summaryUnDone.png" />
                </div>
                <div v-if="row.summary.status == 3" class="icon">
                  <img src="/common/summaryDefault.png" />
                </div>
                <div v-if="row.summary.status == 4" class="icon">
                  <img src="/common/summaryDone.png" />
                </div>
              </a-tooltip>
            </div>
            <!-- 关联vote -->
            <div class="item-checkicon" v-if="row.meetingType !== 2">
              <a-tooltip placement="top" @click.stop="gotoMeetingDetail(row)" data-ga-id="会议-已排会-点击列表会议Vote">
                <template slot="title">
                  <span v-if="row.vote.status == 2">未填写Vote，点击跳转到会议详情页填写</span>
                  <span v-if="row.vote.status == 3">进入Vote</span>
                  <span v-if="row.vote.status == 4">已填写Vote，点击查看</span>
                </template>
                <div v-if="row.vote.status == 2" class="icon">
                  <img src="/common/voteUnDone.png" />
                </div>
                <div v-if="row.vote.status == 3" class="icon">
                  <img src="/common/voteDefault.png" />
                </div>
                <div v-if="row.vote.status == 4" class="icon">
                  <img src="/common/voteDone.png" />
                </div>
              </a-tooltip>
            </div>
          </div>
        </div>
        <div slot="manageAction" slot-scope="row" class="manage-action" v-if="btnPermission.includes('update') && !row.ifCanManage">
          <a-button
            v-if="row.meetingUsers && (!row.meetingUsers.find(_ => _.realStatus) || !row.conclusion || !row.realStartTime)"
            type="primary"
            size="small"
            @click.stop="openMeetingEdit(row)"
            >编辑</a-button
          >
          <a-button v-else size="small" @click.stop="openMeetingEdit(row)">编辑</a-button>

          <a-button v-if="row.qualityExpend && row.qualityExpend.status === 2" type="primary" size="small" @click.stop="toQuality(row)">创建品质表</a-button>
          <a-button v-else-if="row.qualityExpend && row.qualityExpend.status === 4" size="small" @click.stop="toQuality(row)">品质表</a-button>
          <a-button v-else size="small" :disabled="true">品质表</a-button>

          <a-button v-if="row.coinExpend && row.coinExpend.status === 2" type="primary" size="small" @click.stop="toCoin(row)">发起投币</a-button>
          <a-button v-else-if="row.coinExpend && row.coinExpend.status === 4" size="small" @click.stop="toCoin(row)">投币</a-button>
          <a-button v-else size="small" :disabled="true">投币</a-button>
        </div>
      </a-table>

      <div class="pagination">
        <a-pagination class="meeting-pagination" :show-total="total => `总计 ${total} 条`" :total="pagination.total" v-model="pagination.page"> </a-pagination>
      </div>
    </div>
    <group-edit :visible="showGroupEdit" @hide="hideGroupEdit" :meetingProjectInfo="meetingProjectInfo"></group-edit>
    <meeting-edit :visible="showMeetingEdit" @hide="hideMeetingEdit" :meetingProjectInfo="meetingProjectInfo"></meeting-edit>
  </div>
</template>
<style lang="less" scoped>
.full-height {
  min-height: calc(100vh - 128px);
}
.filter {
  margin-bottom: 16px;
  margin-top: -12px;
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .title {
      font-size: 14px;
    }
    .filter-item {
      margin: 12px 24px 0 12px;
    }
  }
  .right {
    height: 32px;
    line-height: 32px;
    display: flex;
    margin-top: 12px;
  }
}
.pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  .meeting-pagination {
    margin: 28px 0;
  }
}
.meeting-table {
  cursor: pointer;
  margin-bottom: 12px;
  & /deep/ .ant-table-thead > tr > th,
  & /deep/ .ant-table-tbody > tr > td {
    padding: 12px 12px;
  }
  .tag-list {
    span {
      font-weight: 700;
    }
  }
  .description {
    max-width: 8vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .project-name {
    max-width: 12.5vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .editicon-container {
    a {
      margin: 0 16px 0 0;
    }
  }
  .checkicon-container {
    display: flex;
    flex: 80;
    // justify-content: space-between;
    .item-checkicon {
      width: 20px;
      text-align: center;
      cursor: pointer;
      margin: 0 16px 0 0;
      &:last-child {
        margin: 0;
      }
      .icon {
        position: relative;
        width: 20px;
        height: 20px;
        img {
          width: 100%;
          height: 100%;
        }
        .vote-info {
          position: absolute;
          color: #f52207;
          font-size: 10px;

          // max-width: 120px;
          white-space: nowrap;
          line-height: 28px;
        }
      }
    }
  }
  .manage-action {
    display: flex;
    button {
      margin: 0 4px 0 0;
      &:last-child {
        margin: 0;
      }
    }
  }
}
</style>
<script>
import { meetingList, updateTime, meetingDelete, getDLList, meetingCancel } from '@/api/meeting.js';
import { audioMeetingDetail, audioPermission } from '@/api/project';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { hasPermission } from '@/utils/utils';
import store from '@/store';
import { meetingCategoryMap, meetingListColumns } from '@/utils/meeting';
import groupEdit from '@/components/meeting/groupEdit.vue';
import meetingEdit from '@/components/meeting/meetingEdit.vue';

export default {
  components: {
    groupEdit,
    meetingEdit
  },
  data() {
    return {
      // dateFormat: 'YYYY-MM-DD HH:mm:ss',
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10
      },
      oldPage: 1,
      loading: false,
      hasSuggestPermission: false,
      moment,
      meetingCategoryMap,
      meetingListColumnsRaw: meetingListColumns,
      filterInfo: {
        meetingCategory: undefined,
        isMeetingUser: undefined,
        dl: undefined,
        meetingDate: undefined,
        companyName: undefined
      },
      meetingList: [],
      DLList: [],
      showGroupEdit: false,
      meetingProjectInfo: {},
      showMeetingEdit: false,
      editInfo: {
        startTime: '',
        endTime: '',
        conclusion: ''
      }
    };
  },
  watch: {
    pagination: {
      handler(page) {
        if (this.oldPage !== page.page) {
          this.oldPage = page.page;
          this.getList({
            page: page.page,
            pageSize: page.pageSize
          });
        }
      },
      deep: true
    }
  },
  computed: {
    btnPermission() {
      try {
        const userInfo = this.$store.getters.userInfo;
        const pageInfo = userInfo.permissions.filter(item => item.fullPath === '/meeting');
        const actions = pageInfo[0].children.filter(item => +item.type === 1).map(item => item.value);
        console.log(actions);
        return actions;
      } catch (error) {
        return [];
      }
    },
    meetingListColumns() {
      if (this.btnPermission.includes('update')) {
        return this.meetingListColumnsRaw;
      } else {
        return this.meetingListColumnsRaw.slice(0, this.meetingListColumnsRaw.length - 1);
      }
    }
  },
  methods: {
    // moment,
    toQuality(record) {
      // 通过status判断是新增还是查看 2-新增 4-查看
      console.log(record);
      let isNew = record.qualityExpend.status === 2;
      let path = isNew ? '/systemSetting/manage/projectQuality/createQuality' : '/systemSetting/manage/projectQuality';
      let id = record.qualityExpend.id;
      window.open(window.location.origin + path + (id ? `?id=${id}` : ''));
    },
    toCoin(record) {
      console.log(record);
      let isNew = record.coinExpend.status === 2;
      let path = isNew ? '/systemSetting/manage/createCoin' : '/systemSetting/manage/coin';
      let id = record.coinExpend.id;
      window.open(window.location.origin + path + (id ? `?id=${id}` : ''));
    },
    hideGroupEdit(type, info) {
      if (type !== 'cancel') {
        this.updateTime({
          meetingProjectId: info.meetingProjectId,
          startTime: info.startTime,
          endTime: info.endTime
        });
      }
      this.showGroupEdit = false;
    },
    hideMeetingEdit(type, info) {
      if (type !== 'cancel') {
        this.getList({
          page: this.pagination.page,
          pageSize: 10
        });
      }
      this.showMeetingEdit = false;
    },
    openGroupEdit(row) {
      this.meetingProjectInfo = row;
      this.showGroupEdit = true;
    },
    openMeetingEdit(row) {
      this.meetingProjectInfo = row;
      this.showMeetingEdit = true;
    },
    buildMeeting() {
      this.$router.push('/meeting/createMeeting');
    },
    gotoMeetingDetail(record) {
      let router = this.$router.resolve(`/meeting/detail?companyId=${record.companyId}&meetingProjectId=${record.meetingProjectId}`);
      window.open(router.href);
    },
    //跳转项目详情
    toProjectDetail(v, time, meetingId) {
      if (time) {
        window.open(window.location.origin + `/project/detail?id=${v.companyId}&time=${time}&meetingId=${meetingId}`);
      } else {
        window.open(window.location.origin + `/project/detail?id=${v.companyId}`);
      }
    },
    gotoSummary(v) {
      window.open(window.location.origin + `/project/detail?id=${v.companyId}&meetingPromptId=${v.meetingProjectId}`);
    },

    async gotoAudio(item) {
      if (item.audio.status === 2) {
        this.gotoMeetingDetail(item);
        return;
      }
      try {
        let res = await audioPermission({ meetingProjectId: item.meetingProjectId, meetingType: 1 });
        if (res.code === 200) {
          let url = '';
          let source = item.audio.source;
          if (source === 1) {
            // 请求飞书妙记的url
            let res2 = await audioMeetingDetail({ meetingProjectId: item.meetingProjectId, meetingType: 1 });
            url = res2.data.audioIdPath;
          } else if (source === 0) {
            let routeUrl = this.$router.resolve({
              path: '/project/meetingAudio',
              query: { meetingProjectId: item.meetingProjectId, meetingType: 1 }
            });
            url = routeUrl.href;
          }
          if (url) {
            window.open(url, '_blank');
          } else {
            this.$message.error('无查看权限');
          }
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    toPdfview(id) {
      window.open(window.location.origin + `/pdfview?id=${id}`);
    },
    editClick(row) {
      if (row.ifCanManage)
        this.$router.push({
          path: `/meeting/createMeeting`,
          query: { meetingId: row.id }
        });
    },
    toSuggest(id) {
      window.open(`${window.location.origin}/meeting/suggestParticipates?projectId=${id}`);
    },
    showConfirm(row) {
      let _this = this;
      if (row.ifCanManage) {
        this.$confirm({
          title: '删除会议',
          width: 500,
          content: h => (
            <div>{row.meetingGoal === 8 ? <div>确定删除吗？</div> : <div>删除后，此项目将返回到待排会页面，并取消所有参会人的飞书日程，确定删除吗？</div>}</div>
          ),
          onOk() {
            _this.meetingCancel(row);
          },
          onCancel() {}
        });
      }
    },
    handleFilterChange(id, value = {}) {
      this.$ga.gaUploadCustomEvent(id, value);
      this.pagination.page = 1;
      this.getList();
    },
    async meetingCancel(row) {
      try {
        let res = await meetingCancel({
          meetingProjectId: row.meetingProjectId
        });
        if (res.code === 200) {
          if (row.meetingGoal === 8) {
            this.$message.success('删除成功');
          } else {
            this.$message.success('删除成功，该项目已经返回到待排会页面');
          }
          this.getList({
            page: this.pagination.page,
            pageSize: 10
          });
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async updateTime(data) {
      try {
        let res = await updateTime(data);
        if (res.code === 200) {
          this.$message.success('修改成功!');
          this.getList({
            page: this.pagination.page,
            pageSize: 10
          });
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async getDLList() {
      try {
        let res = await getDLList();
        if (res.code === 200) {
          let obj = {};
          this.DLList = res.data;
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async getList(data) {
      try {
        data = data
          ? data
          : {
            page: 1,
            pageSize: 10
          };
        let timeRange = this.filterInfo.meetingDate
          ? {
            startTime: this.filterInfo.meetingDate
              .clone()
              .startOf('day')
              .unix(),
            endTime: this.filterInfo.meetingDate
              .clone()
              .add(1, 'd')
              .startOf('day')
              .subtract(1, 's')
              .unix()
          }
          : {};
        this.loading = true;
        let res = await meetingList({
          ...data,
          ...this.filterInfo,
          ...timeRange
        });
        if (res.code === 200) {
          this.meetingList = res.data.list;
          this.pagination.total = res.data.total;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$message.error(e);
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.indexOf(input) >= 0;
    }
  },

  created() {
    const queue = [...store.getters.userInfo.permissions];
    this.hasSuggestPermission = hasPermission(queue, '/meeting/suggestParticipates');
    this.hasCreatePermission = hasPermission(queue, '/meeting/createMeeting');
  },

  mounted() {
    this.getList({
      page: this.pagination.page,
      pageSize: this.pagination.pageSize
    });
    this.getDLList();
  }
};
</script>
